<template>
    <div class="row d-flex">
        <div class="live-video-thumb col-xl-3 col-6" v-for="(item, i) in lives" :key="item.id">
            <p class="text">Live {{ (i+1) }}</p>
            <img :src="imgClickHere" 
                @click="$emit('loadLive', {show: true, file: {name: item.name, videoPath:item.url, number:i+1}})" alt="Live">
        </div>
    </div>
</template>
  
<script lang="ts">
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'

export default {
    name: 'LastLives',
    props: ['lives'],
    emits: ['loadLive'],    
    computed: {
        ...mapState(localeStore, ['locale']),
    },
    data() {
        return {
            imgClickHere: ''
        }
    },
    watch: {
        'locale': function () {
            this.imgClickHere = `https://api.belladasemana.com.br/assets/img/live_video_watch_thumb_${this.locale}.jpg`
        }
    },
    mounted() {
        this.imgClickHere = `https://api.belladasemana.com.br/assets/img/live_video_watch_thumb_${this.locale}.jpg`
    },
}
</script>
<style scoped>
.text {
    margin-top: 30px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 24px;
    letter-spacing: 0;
    line-height: 24px;
}
.live-video-thumb img {
    width: 100%;
    cursor: pointer;
}
</style>